{
  "title": "Привіт, {{name}}!",
  "myData": "Мої дані:",
  "saveButton": {
    "isLoading": "Зберігаємо...",
    "default": "Зберегти зміни",
    "isDone": "Зміни збережено"
  }
}
